import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';

export default function TabNavigation({ tabs, activeTab, onTabPress, style }) {
  const renderTabButton = (tab) => (
    <TouchableOpacity
      key={tab.key}
      style={[
        styles.tabButton,
        activeTab === tab.key && styles.activeTabButton,
      ]}
      onPress={() => onTabPress(tab.key)}
    >
      <Text style={[
        styles.tabButtonText,
        activeTab === tab.key && styles.activeTabButtonText,
      ]}>
        {tab.label}
      </Text>
    </TouchableOpacity>
  );

  return (
    <View style={[styles.tabContainer, style]}>
      {tabs.map(renderTabButton)}
    </View>
  );
}

const styles = StyleSheet.create({
  tabContainer: {
    flexDirection: 'row',
    backgroundColor: 'white',
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  tabButton: {
    flex: 1,
    paddingVertical: 12,
    marginHorizontal: 4,
    backgroundColor: 'transparent',
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
  },
  activeTabButton: {
    backgroundColor: 'transparent',
    borderBottomColor: '#000',
  },
  tabButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#666',
    fontFamily: 'Poppins-Medium',
  },
  activeTabButtonText: {
    color: '#000',
  },
});